import { render, staticRenderFns } from "./LogSummaryPage.vue?vue&type=template&id=52b67342"
import script from "./LogSummaryPage.vue?vue&type=script&lang=js"
export * from "./LogSummaryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports